import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { PreviousContributionModel } from 'src/app/model/previous-contribution.model';

export const RequestAction = createAction('[Processed Contributions view overview] get data', props<{ page: number }>());
export const ResponseAction = createAction('[Processed Contributions view overview] set data',  props<{ payload: PreviousContributionModel[] }>());
export const LoadMoreAction = createAction('[Processed Contributions view overview] load more');
export const ResetPageAction = createAction('[Processed Contributions view overview] reset');
